<template>
  <table class="table">
    <tbody>
      <tr>
        <td class="table-label">Energy</td>
        <td colspan="1" v-if="standardTariffGas">Gas</td>
        <td v-if="standardTariffElectricity">Electricity</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Annual Consumption</td>
        <td colspan="1" v-if="standardTariffGas">{{ standardTariffGas.annualUsage | number }} <small>kWh</small></td>
        <td v-if="standardTariffElectricity">{{ standardTariffElectricity.annualUsage | number }} <small>kWh</small></td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Date of Calculation </td>
        <td colspan="1" v-if="standardTariffGas">{{ standardTariffGas.dateOfCalculation | date }}</td>
        <td v-if="standardTariffElectricity">{{ standardTariffElectricity.dateOfCalculation | date }}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Supplier</td>
        <td colspan="1" v-if="standardTariffGas">{{ standardTariffGas.supplier }}</td>
        <td v-if="standardTariffElectricity">{{ standardTariffElectricity.supplier }}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Tariff Name</td>
        <td colspan="1" v-if="standardTariffGas">{{ standardTariffGas.tariffName }}</td>
        <td v-if="standardTariffElectricity">{{ standardTariffElectricity.tariffName }}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Days Left On Current Tariff</td>
        <td colspan="1" v-if="standardTariffGas">{{ standardTariffGas.daysOnDefaultTariff }}</td>
        <td v-if="standardTariffElectricity">{{ standardTariffElectricity.daysOnDefaultTariff }}</td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Standing Charge</td>
        <td colspan="1" v-if="standardTariffGas">{{ standardTariffGas.standingCharge  }} <small>p/day</small></td>
        <td v-if="standardTariffElectricity">
          {{ standardTariffElectricity.standingCharge }} <small>p/day</small>
        </td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Unit rate <small>(p/kWh)</small></td>
        <td colspan="1" v-if="standardTariffGas">{{ standardTariffGas.unitRate }}</td>
        <td v-if="standardTariffElectricity">
          <div v-if="!standardTariffElectricity.unitRateNight">
            {{ standardTariffElectricity.unitRateDay }}
          </div>

          <div class="row" v-if="standardTariffElectricity.unitRateNight">
            <div class="col-xs-6">
              <div>
                {{ standardTariffElectricity.unitRateDay }}
              </div>
              <small>Day</small>
            </div>

            <div class="col-xs-6">
              <div>
                {{ standardTariffElectricity.unitRateNight }}
              </div>
              <small>Night</small>
            </div>
          </div>
        </td>
      </tr>

      <tr v-if="showMore">
        <td class="table-label" style="width:40%;">Discounts</td>
        <td colspan="1" v-if="standardTariffGas">{{ standardTariffGas.discounts | currency(2)}}</td>
        <td v-if="standardTariffElectricity">{{ standardTariffElectricity.discounts | currency(2)}}</td>
      </tr>

      <tr v-if="standardTariffElectricity || standardTariffGas">
        <td class="table-label" style="width:40%;">Remaining Cost of Fixed Price Tariff</td>
        <td colspan="1" v-if="standardTariffGas"><strong>{{ standardTariffGas.personalProjection | currency(2)}}</strong></td>
        <td v-if="standardTariffElectricity"><strong>{{ standardTariffElectricity.personalProjection | currency(2)}}</strong></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'StandardTariffTable',
  props: {
    gasData: Object,
    electricityData: Object,
    standardTariffGas: Object,
    standardTariffElectricity: Object,
    showMore: {
      type: Boolean,
      default: []
    }
  }
};
</script>

<style lang="scss" src="./standard-tariff-table.scss"></style>
